import { ENDPOINTS } from "utils/api";
import { get, post } from "../utils/api/apiCaller";

export const getConversations = (projectId: string) =>
  get(ENDPOINTS.MESSAGE_MODULE.CONVERSATIONS(projectId));

export const getMessages = (projectId: string, conversationId: string, page = 1, limit = 20) =>
  get(ENDPOINTS.MESSAGE_MODULE.MESSAGES(projectId, conversationId, page, limit));

export const sendMessage = (projectId: string, conversationId: string, body: string) =>
  post(ENDPOINTS.MESSAGE_MODULE.SEND_MESSAGE(projectId, conversationId), { body });
